import { actions } from 'src/constants';

const initialState = {
  data: {},
  hasLoaded: false,
  isLoading: false,
};

const actionMap = {
  [actions.DISCOVER_STEP_ONE_COLLECTIONS_GET_REQUEST]: (state) => ({
    ...state,
    data: initialState.data,
    hasLoaded: false,
    isLoading: true,
  }),
  [actions.DISCOVER_STEP_ONE_COLLECTIONS_GET_SUCCESS]: (state, { result }) => ({
    ...state,
    data: result.data,
    hasLoaded: true,
    isLoading: false,
  }),
  [actions.DISCOVER_STEP_ONE_COLLECTIONS_GET_FAILURE]: (state) => ({
    ...state,
    hasLoaded: false,
    isLoading: false,
  }),
};

export default (state = initialState, action) => {
  if (actionMap[action.type]) {
    return actionMap[action.type](state, action);
  }

  return state;
};
